// extracted by mini-css-extract-plugin
export default {"tag":"PriceStatusIndicator_tag__evceH"};